export const infoPages = [
  {
    path: "about-us",
    source: "page",
    handle: "about-us",
    footerKey: "information.aboutUs",
    footerGroup: "brand",
  },
  {
    path: "payment-options",
    source: "page",
    handle: "payment-options",
    footerKey: "information.paymentOptions",
    footerGroup: "information",
  },
  {
    path: "ordering-and-delivery",
    source: "policy",
    policyKey: "shippingPolicy",
    footerKey: "information.deliveryInfo",
    footerGroup: "information",
  },
  {
    path: "terms-of-use",
    source: "policy",
    policyKey: "termsOfService",
    footerKey: "information.termsAndConditions",
    footerGroup: "legal",
  },
  {
    path: "return-policy",
    source: "policy",
    policyKey: "refundPolicy",
    footerKey: "information.returns",
    footerGroup: "information",
  },
  {
    path: "security-and-privacy-policy",
    source: "policy",
    policyKey: "privacyPolicy",
    footerKey: "information.privacyPolicy",
    footerGroup: "legal",
  },
  {
    path: "faq",
    source: "page",
    handle: "faq",
    footerKey: "information.faq",
    footerGroup: "information",
  },
  {
    path: "contact-information",
    source: "policy",
    policyKey: "contactInformation",
    footerKey: "information.contactUs",
    footerGroup: "information",
  },
  {
    path: "withdrawal-form",
    source: "page",
    handle: "withdrawal-form",
    footerKey: "information.withdrawalForm",
    footerGroup: "legal",
  },
  {
    path: "complaints",
    source: "page",
    handle: "complaints",
    footerKey: "information.complaints",
    footerGroup: "legal",
  },
  {
    path: "cookies",
    source: "page",
    handle: "cookies",
    footerKey: "information.cookies",
    footerGroup: "legal",
  },
  // Withdrawal function (Consumer Protection Act art. 81.a), a form with no Shopify content.
  {
    path: "withdraw",
    source: "form",
    footerKey: "information.withdrawal",
    footerGroup: "legal",
  },
  // Daily price list files (Odluka NN 101/2026, from 17.11.2026), no Shopify content.
  {
    path: "price-list",
    source: "form",
    footerKey: "information.priceList",
    footerGroup: "legal",
  },
  // Company details required on the website (ZTD art. 21, ZET art. 6).
  {
    path: "legal-notice",
    source: "policy",
    policyKey: "legalNotice",
    footerKey: "information.legalNotice",
    footerGroup: "legal",
  },
] as const;

export type InfoPage = (typeof infoPages)[number];
export type InfoPagePath = InfoPage["path"];

export const getInfoPageTo = (path: InfoPagePath) =>
  `/$locale/info/${path}` as const;

export const getInfoPageStaticPath = (path: InfoPagePath) => `/info/${path}`;

export const sidebarInfoPages = infoPages;
export const mobileMenuInfoPages = infoPages.filter(
  (page) => page.footerGroup !== "brand",
);
export const informationFooterPages = infoPages.filter(
  (page) => page.footerGroup === "information",
);
export const legalFooterPages = infoPages.filter(
  (page) => page.footerGroup === "legal",
);
export const brandFooterPage = infoPages.find(
  (page) => page.footerGroup === "brand",
);
